import { observer } from "mobx-react-lite";
import * as React from "react";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { NGFormElement } from "../../../../newcomponents/ngformelement/ngformelement";
import { DryRunAlert } from "../../dryRunAlert";
import { mk8sDryRun } from "../../../../mobxStores/dryRun/mk8s";
import { CodeEditor } from "../../../group/identityMatcher/codeEditor";
import { NGLabel } from "../../../../newcomponents/text/label";
import { ExternalLink } from "../../../../newcomponents/table/components/ExternalLink";
import { DOCS_URL } from "../../../../envVariables";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import jsYaml from "js-yaml";
import NGAlert from "../../../../newcomponents/alert";
import { ByokDryRunMessage } from "../../addons/byokDryRunMessage";
import { NGSwitch } from "../../../../newcomponents/switch";
import { NGLabelText } from "../../../../newcomponents/text/labelText";
import { InfoTooltip } from "../../../../components/InfoTooltip";
import { getDefaultByokConfig } from "../../../../mst/stores/mk8s.draft.addon.byok";

interface Props {
  mk8sDraft: Mk8sDraftMobx;
}
const CreateAddonsByokRaw: React.FC<Props> = ({ mk8sDraft }) => {
  const [showProperties, setShowProperties] = React.useState(false);

  return (
    <div>
      <div className="mb-4">
        <DryRunAlert
          key={mk8sDryRun.key}
          canShow={true}
          dryRunResponse={mk8sDryRun.response}
          path={"spec.addOns.byok"}
        />
      </div>
      <div className="mb-2">BYOK</div>
      <div className="flex gap-2 items-start">
        <NGFormElement
          as={`kindselect`}
          kind="location"
          name={`byok.location`}
          label={`Location`}
          description="Location cannot be changed after byok addon is enabled"
          value={mk8sDraft.addon_byok.location}
          required={true}
          onChange={mk8sDraft.addon_byok.setLocation}
          kindSelectProps={{
            queries: [{ property: "provider", value: "byok" }],
          }}
        />
        <div className="mt-6">
          <DryRunAlert
            key={mk8sDryRun.key}
            canShow={true}
            dryRunResponse={mk8sDryRun.response}
            onFix={mk8sDraft.addon_byok.setLocation}
            path={"spec.addOns.byok.location"}
          />
        </div>
      </div>
      <div className="flex items-center mb-4">
        <NGSwitch
          value={mk8sDraft.addon_byok.ignoreUpdates}
          onChange={(checked) => mk8sDraft.addon_byok.setIgnoreUpdates(checked)}
        >
          <NGLabelText>Ignore Updates</NGLabelText>
        </NGSwitch>
        <InfoTooltip title={["Prevents any byok updates by scaling cpln-byok-agent deployment to 0 replicas"]} />
      </div>
      <div>
        <NGLabel>BYOK Addon Config</NGLabel>
      </div>
      <div className="flex items-center gap-1">
        See <ExternalLink label="byok addon documentation" url={`${DOCS_URL}/byok/overview`} disableCopy /> for details
      </div>
      <CodeEditor
        value={mk8sDraft.addon_byok.config}
        setValue={(value) => mk8sDraft.addon_byok.setConfig(value)}
        options={{ basicSetup: { lineNumbers: true } }}
        language="yaml"
      />
      {mk8sDraft.addon_byok.asObject === false ? (
        <NGAlert type="error" title="Config is not in the correct schema" />
      ) : (
        <ByokDryRunMessage />
      )}
      <div className="mt-6 flex items-center gap-2">
        <NGLabel>Config Default Values</NGLabel>
        {showProperties ? (
          <UpOutlined className="color-link" onClick={() => setShowProperties((x) => !x)} />
        ) : (
          <DownOutlined className="color-link" onClick={() => setShowProperties((x) => !x)} />
        )}
      </div>
      {showProperties ? (
        <CodeEditor
          value={jsYaml.dump(getDefaultByokConfig())}
          setValue={(value) => mk8sDraft.addon_byok.setConfig(value)}
          options={{ basicSetup: { lineNumbers: false }, readOnly: true, style: { fontSize: 14 } }}
          language="yaml"
        />
      ) : null}
    </div>
  );
};

export const CreateAddonsByok = observer(CreateAddonsByokRaw);
